'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay/classic');

// Components
const DetailsReturnModal = require('./DetailsReturnModal');

// Helpers
const { trackGaEvent } = require('../../helpers/pdpTracking');
const get = require('lodash.get');

class DetailsReturnLink extends React.Component {
    constructor(props) {
        super(props);
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);

        this.state = {
            returnDetailModalOpen: false,
        };
    }

    onOpen(e) {
        e.preventDefault();
        const { item } = this.props;
        const description = get(item, `returnPolicy.accept`, false)
            ? 'returns accepted'
            : 'returns not accepted';

        trackGaEvent('product', 'view return details', `pdp description|${description}`);
        this.setState({
            returnDetailModalOpen: true,
        });
    }

    onClose() {
        this.setState({
            returnDetailModalOpen: false,
        });
    }

    render() {
        const { href, text, item, userId } = this.props;

        return (
            <div>
                <a onClick={this.onOpen} href={href}>
                    {text}
                </a>
                <DetailsReturnModal
                    item={item}
                    userId={userId}
                    isOpen={this.state.returnDetailModalOpen}
                    onClose={this.onClose}
                />
            </div>
        );
    }
}

DetailsReturnLink.propTypes = {
    context: PropTypes.object,
    userId: PropTypes.string,
    item: PropTypes.object,
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

module.exports = Relay.createContainer(DetailsReturnLink, {
    initialVariables: {
        userId: null,
    },
    fragments: {
        item: ({ userId }) => Relay.QL`
                fragment on Item {
                    ${DetailsReturnModal.getFragment('item', { userId })}
                    returnPolicy {
                        accept
                    }
                }
            `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/DetailsReturnLink.jsx